export default __webpack_public_path__ + "static/media/2-step.2d5e931d.svg";